import { createAsyncAction } from "typesafe-actions";
const domain = "user-profile";
const userProfileActions = {
  /**
   * @deprecated
   * <p>Should be removed. Use bo-operation/features/block-download</p>
   */
  download: createAsyncAction(`${domain}/downloadRequest`, `${domain}/downloadSuccess`, `${domain}/downloadFailure`)(),
  updatePlayerId: createAsyncAction(
    `${domain}/updatePlayerIdRequest`,
    `${domain}/updatePlayerIdSuccess`,
    `${domain}/updatePlayerIdFailure`
  )(),
  updateAgentRevenueShare: createAsyncAction(
    `${domain}/updateAgentRevenueShareRequest`,
    `${domain}/updateAgentRevenueShareSuccess`,
    `${domain}/updateAgentRevenueShareFailure`
  )(),
  updateNonWDBalance: createAsyncAction(
    `${domain}/updateNonWdBalanceRequest`,
    `${domain}/updateNonWdBalanceSuccess`,
    `${domain}/updateNonWdBalanceFailure`
  )(),
  copyReferralCode: createAsyncAction(
    `${domain}/copyReferralCodeRequest`,
    `${domain}/copyReferralCodeSuccess`,
    `${domain}/copyReferralCodeFailure`
  )()
};
export {
  userProfileActions
};
//# sourceMappingURL=actions.js.map
